// File preview based on https://codepen.io/marcelo-ribeiro/pen/wEqJXp
// File drag drop based on https://stackoverflow.com/a/65778680/11533449

/// File upload
$(function () {
    // File preview
    var fileInputs = document.querySelectorAll('.fileUploadWithPreview .field_wrap.__file .input_wrap input');
    var fileSubmit = document.querySelector('.fileUploadSubmit');

    fileInputs.forEach((fileInput) => {
        fileInput.addEventListener('change', updateFileDisplay);
        var parent = fileInput.closest('.field_wrap.__file')
        createPreview(parent);
    });

    function createPreview(element) {
        createFilePreview = document.createElement('div');
        createFilePreview.className = 'preview_wrap';
        element.appendChild(createFilePreview)
    }

    function updateFileDisplay() {
        var fileParent = this.closest('.field_wrap.__file');
        var filePreview = fileParent.querySelector('.preview_wrap');

        fileParent.classList.add("active");

        fileSubmit.style.display = 'block';
        setTimeout(function () {
            fileSubmit.style.opacity = 1;
        }, 1);

        while (filePreview.firstChild) {
            fileParent.classList.remove("active");
            filePreview.removeChild(filePreview.firstChild);
        }

        var files = this.files;

        if (!files.length) {
            var fileItem = document.createElement('p');
            fileItem.textContent = '';
            filePreview.appendChild(fileItem);
        } else {
            var fileList = document.createElement('ol');
            filePreview.appendChild(fileList);

            for (var i = 0; i < files.length; i++) {
                var fileListItem = document.createElement('li');
                var fileItem = document.createElement('p');

                fileItem.textContent = files[i].name;
                fileListItem.appendChild(fileItem);
                fileList.appendChild(fileListItem);
            }
        }
    }

    // File drag and drop
    var fileDrops = document.querySelectorAll('.field_wrap.__file');

    // Create change event
    const eventChange = new Event("change");

    fileDrops.forEach((fileDrop) => {
        fileDrop.ondragover = function (e) {
            e.preventDefault();
            this.classList.add('dragover');
        };
        fileDrop.ondragleave = function (e) {
            e.preventDefault();
            this.classList.remove('dragover');
        };
        fileDrop.ondrop = function (e) {
            e.preventDefault();
            this.classList.remove('dragover');
            this.querySelector('input').files = e.dataTransfer.files;
            this.querySelector('input').dispatchEvent(eventChange);
        }
    });
});